import { Component, services } from '@contorion/core';
import { IDynamicYieldService } from '../interfaces/dynamic-yield-service.interface';

export default abstract class AbstractEngagementComponent extends Component {
    protected dynamicYieldService: IDynamicYieldService;
    protected abstract bindEvents(): void;

    constructor(protected element: HTMLElement) {
        super(element);

        this.init();
    }

    protected async init(): Promise<void> {
        this.dynamicYieldService = await services.get('dynamic-yield-service');
        this.bindEvents();
    }
}
